import React,{ useEffect, useState, useRef } from "react"
import { useProfileForm, ProfileSchemaType, ProfileFormHookReturn } from "../../../utils/hooks/useProfileForm"
import { Container, Modal, useMediaQuery, IconButton, Typography, 
    Stack, List, ListItem, Card, ListItemButton, Collapse, Button, Grid, Box, TextField, ThemeProvider, Divider, InputAdornment } from "@mui/material"
import { theme } from '../../../config/Dashboardtheme'
import { emptyProfileSchema, fromProfileFields } from "@meprism/shared/src/schemas/EmployeeProfileForm"
  import { useAppDispatch } from '../../../redux/storeExports'
import closeicon from '@meprism/shared/src/assets/icons/successclose.png'
import {ExpandLess, ExpandMore} from '@mui/icons-material'
import shieldicon from '@meprism/shared/src/assets/icons/shieldgrey.svg'
import {
    Controller,
    FieldValues,
    UseFieldArrayReturn,
    UseFormWatch,
  } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import PageLayout from "../../layouts/ExecUserProfileDashboardPageLayout"
import nexticon from '@meprism/shared/src/assets/icons/next.svg'
import { UpdateExecutiveUserLinkedIn, FetchExecutiveEmployeeProfile } from "@meprism/shared/src/redux/profile/ProfileSlice"
import { DatePicker ,LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MpTheme from '@meprism/shared/src/config/MpTheme'
import {Toast} from '../../toast/toast'
import deleteIcon from '@meprism/shared/src/assets/icons/Delete.svg'
import editIcon from '@meprism/shared/src/assets/icons/Pencil.svg'
import CountryCode from '@meprism/shared/src/assets/icons/countrycode.svg'
import CircularProgress from '@mui/material/CircularProgress';

interface ProfileDashboardProps {
  muid: string
  isModalOpen: boolean
  setIsModalOpen: (open: boolean) => void
}

interface SidebarProps {
    sections: string[]
    onSectionChange: (sectionIndex: number) => void
  }
  
  interface PersonalInfoSectionProps {
    firstNameArray: UseFieldArrayReturn<ProfileSchemaType, 'firstName', 'id'>
    middleNameArray: UseFieldArrayReturn<ProfileSchemaType, 'middleName', 'id'>
    lastNameArray: UseFieldArrayReturn<ProfileSchemaType, 'lastName', 'id'>
    otherFirstNameArray: UseFieldArrayReturn<
      ProfileSchemaType,
      'otherFirstName',
      'id'
    >
    otherMaidenNameArray: UseFieldArrayReturn<
      ProfileSchemaType,
      'otherMaidenName',
      'id'
    >
    register: ProfileFormHookReturn['register']
    trigger: ProfileFormHookReturn['trigger']
    errors: ProfileFormHookReturn['formState']['errors']
    control?: ProfileFormHookReturn['control']
    setValue: ProfileFormHookReturn['setValue']
    watch: UseFormWatch<ProfileSchemaType>
    muid: string
  }
  
  interface LocationsAddressesSectionProps {
    addressArray: UseFieldArrayReturn<ProfileSchemaType, 'address', 'id'>
    register: ProfileFormHookReturn['register']
    errors: ProfileFormHookReturn['formState']['errors']
    control?: ProfileFormHookReturn['control']
  }
  
  interface ContactInfoSectionProps {
    emailArray: UseFieldArrayReturn<ProfileSchemaType, 'email', 'id'>
    phoneNumberArray: UseFieldArrayReturn<ProfileSchemaType, 'phoneNumber', 'id'>
    register: ProfileFormHookReturn['register']
    errors: ProfileFormHookReturn['formState']['errors']
    control?: ProfileFormHookReturn['control']
    setValue: ProfileFormHookReturn['setValue']
  }
  
  const styles = {
    inputContainer: {
      width: '100%',
      marginLeft: '0px',
    },
    header: {
      color: '#040115',
      mb: 5,
    },
    fullWidth: {
      width: '100%',
    },
    required: {
      '&:after': {
        content: '"*"',
        color: '#615F6B',
      },
    },
    textField: {
      background: '#EFEDFDB2',
    },
  
    mb1: {
      marginBlock: '1rem',
    },
    borderBlack: {
      borderColor: '#a5a1a1',
    },
    fieldlabel:{
      mb: 1
    }
  } as const

  const Sidebar: React.FC<SidebarProps> = ({sections, onSectionChange}) => {
    const [selectedSection, setSelectedSection] = useState<number>(0)
    return (
      <Card
        sx={{
          width: '280px',
          height: 'auto'        
          }}>
        <List>
        {sections.map((section, index) => 
            <ListItemButton
                selected={index === selectedSection}
                sx={{borderBottom: index!= sections.length-1?'1px solid #A0A0A4' : 'none'}}
                key={index}
                onClick={() => {
                    setSelectedSection(index)
                    onSectionChange(index)
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}>
                    <div
                      style={{
                        color: index === selectedSection ? '#1A1B20' : '#615F6B',
                      }}>
                      {section}
                    </div>
                    <img
                      src={nexticon}
                      alt="Description of the image"
                      style={{maxWidth: '100%', maxHeight: '100%'}}
                    />
                  </div>
            </ListItemButton>)}
        </List>
      </Card>
    )
  }
  
  const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
                                                                   register,
                                                                   trigger,
                                                                   errors,
                                                                   control,
                                                                   firstNameArray,
                                                                   lastNameArray,
                                                                   middleNameArray,
                                                                   otherFirstNameArray,
                                                                   otherMaidenNameArray,
                                                                   setValue,
                                                                   watch,
                                                                   muid
                                                                 }) => {
  const linkedInValue = watch('linkedIn');
  const originalLinkedInRef = useRef('');
  const [hasChanged, setHasChanged] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (linkedInValue && originalLinkedInRef.current === '') {
      originalLinkedInRef.current = linkedInValue;
    }
    setHasChanged(linkedInValue !== originalLinkedInRef.current);
  }, [linkedInValue]);

  const handleLinkedinUpdate = async () => {
    if (linkedInValue && hasChanged) {
      try {
        await dispatch(UpdateExecutiveUserLinkedIn({linkedIn_url: linkedInValue, muid: muid}));
        originalLinkedInRef.current = linkedInValue;
        setHasChanged(false);
      } catch (error) {
        console.error('Error Updating linkedIn URl : ',error)
      }
    }
  };

  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <>
      <ThemeProvider theme={theme}>
        {!isMobile && (
          <Typography variant="h3" sx={styles.header}>
            Basic Info
          </Typography>
        )}
        <Stack spacing={3} display={'flex'} flexDirection={'column'}>
          <Typography variant="h5" mb={5}>
            We use your information to look for additional records of yours.
            Additional information like alternative names helps us find more of
            your data.
          </Typography>

          <Stack spacing={3} display={'flex'} flexDirection={['column', 'row']}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{width: '100%'}}>
              {firstNameArray.fields[0] && (
                <Grid item md={3} sm={12} sx={{width: '100%'}}>
                  <Typography
                    variant="h4"
                    color={'#615F6B'}
                    sx={styles.required}>
                    First Name
                  </Typography>
                  <TextField
                    fullWidth
                    required
                    disabled={true}
                    defaultValue={''}
                    error={!!errors?.firstName?.[0]?.value}
                    helperText={errors?.firstName?.[0]?.value?.message}
                    InputLabelProps={{shrink: true}}
                    {...register(`firstName.${0}.value` as const)}
                    style={{borderRadius: 5, backgroundColor: "#EFEDFDB2", color:"#A0A0A4"}}
                    sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                    onChange={(e) => {
                      firstNameArray.update(0, {value: e.target.value})
                    }}
                  />
                </Grid>
              )}
              {middleNameArray.fields[0] && (
                <Grid item md={3} sm={12} sx={{width: '100%'}}>
                  <Typography
                    variant="h4"
                    color={'#615F6B'}
                    sx={styles.inputContainer}>
                    Middle Name
                  </Typography>
                  <TextField
                    fullWidth
                    disabled={true}
                    defaultValue={''}
                    error={!!errors?.middleName?.[0]?.value}
                    helperText={errors?.middleName?.[0]?.value?.message}
                    InputLabelProps={{shrink: true}}
                    {...register(`middleName.${0}.value` as const)}
                    style={{borderRadius: 5, backgroundColor: "#EFEDFDB2", color:"#A0A0A4"}}
                    sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                  />
                </Grid>
              )}
              {lastNameArray.fields[0] && (
                <Grid item md={3} sm={12} sx={{width: '100%'}}>
                  <Typography
                    variant="h4"
                    color={'#615F6B'}
                    sx={styles.required}>
                    Last Name
                  </Typography>
                  <TextField
                    fullWidth
                    disabled={true}
                    error={!!errors?.lastName?.[0]?.value}
                    helperText={errors?.lastName?.[0]?.value?.message}
                    InputLabelProps={{shrink: true}}
                    defaultValue={''}
                    {...register(`lastName.${0}.value` as const)}
                    style={{borderRadius: 5, backgroundColor: "#EFEDFDB2", color:"#A0A0A4"}}
                    sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Stack>
          <Stack spacing={3} display={'flex'} flexDirection={['column', 'row']}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent={'space-between'}
              sx={{width: '100%'}}>
              <Grid item md={9} sm={12} sx={{width: isMobile? '100%':'60%'}}>
                <Typography variant="h4" color={'#615F6B'}>
                  LinkedIn URL
                </Typography>
                <TextField
                  fullWidth
                  // disabled={true}
                  defaultValue={linkedInValue}
                  error={!!errors?.linkedIn}
                  helperText={errors?.linkedIn?.message}
                  InputLabelProps={{shrink: true}}
                  {...register('linkedIn', {
                    onChange: async (e) => {
                      setValue('linkedIn', e.target.value)
                      await trigger('linkedIn')
                    },
                    onBlur: async () => {
                      await trigger('linkedIn')
                    },
                  })}
                  sx={{'& input': {
                    p:0
                    },
                    '& .MuiOutlinedInput-root': {
                    fontSize: '14px',
                    p:5,
                    borderWidth: 0
                    },
                    backgroundColor:MpTheme.colors.white,
                    '& input:-webkit-autofill': {
                    background: 'transparent',
                    WebkitBoxShadow: '0 0 0 1000px white inset',
                    WebkitTextFillColor: '#000000',
                    },
                    '&.MuiTextField-root': {
                    border: 'none',
                    },
                }}
                />
              </Grid>
              <Grid item md={3} sm={12} sx={{width: '100%'}}>
                <Button
                  variant={'contained'}
                  color={'darkPurple'}
                  disabled={!hasChanged}
                  sx={{
                    height: 40,
                    marginTop: 4,
                    borderRadius: '10px',
                    boxShadow: 'unset',
                    border: '2px solid #C67EFF',
                    background: 'transparent',
                    color: '#C67EFF',
                    '&.Mui-disabled': {
                      background: 'transparent',
                      color: '#A0A0A4',
                      border: '2px solid #A0A0A4',
                      opacity: 0.7,
                    },
                    ':hover': {
                      background: 'transparent',
                      color: '#C67EFF',
                    },
                  }}
                  onClick={handleLinkedinUpdate}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </Stack>
          <Stack spacing={2} display={'flex'} flexDirection={['column', 'row']}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{width: '100%'}}>
              <Grid item md={3} sm={12} sx={{width: '100%'}} mb={5}>
                <Typography variant="h4" color={'#615F6B'} sx={styles.required}>
                  Birthdate
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name={'birthdate'}
                  control={control}
                  render={({field}) => (
                    <DatePicker
                      disabled={true}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          error={!!errors?.birthdate}
                          helperText={errors?.birthdate?.message ?? ''}
                          style={{borderRadius: 5, backgroundColor: "#EFEDFDB2", color:"#A0A0A4"}}
                          sx={{'& input': {
                            p:0
                            },
                            '& .MuiOutlinedInput-root': {
                            fontSize: '14px',
                            p:5,
                            borderWidth: 0
                            },
                            '&.MuiTextField-root': {
                            border: 'none',
                            },
                        }}
                        />
                      )}
                      {...field}
                    />
                  )}
                />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Stack>
          <Divider sx={Object.assign({}, styles.borderBlack, styles.mb1)}/>
          <Stack spacing={3} display={'flex'} flexDirection={'column'}>
            <Typography variant="h3" sx={styles.header}>
              Other Names
            </Typography>
            <Typography variant="h5" mb={10}>
              Optional: You can include alternative names like nicknames, maiden
              names, or names from marriage changes. For example,
              &quot;Robert&quot; could be &quot;Bob&quot;. We&apos;ll use
              whatever full name you provide to conduct our search.
            </Typography>
            <Stack
              spacing={3}
              display={'flex'}
              flexDirection={['column', 'row']}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{width: '100%'}}>
                <Grid item md={3} sm={12} sx={{width: '100%'}}>
                  <Typography
                    variant="h4"
                    color={'#615F6B'}
                    // sx={styles.required}
                  >
                    First Name
                  </Typography>
                  <TextField
                    fullWidth
                    disabled={otherFirstNameArray.fields[0]?.value !== ''}
                    defaultValue={''}
                    InputLabelProps={{shrink: true}}
                    {...register(`otherFirstName.0.value` as const)}
                    error={!!errors?.otherFirstName?.[0]?.value}
                    helperText={
                      errors?.otherFirstName?.[0]?.value?.message || ''
                    }
                    style={{borderRadius: 5, backgroundColor: MpTheme.colors.white}}
                    sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        backgroundColor:MpTheme.colors.white,
                        '& input:-webkit-autofill': {
                        background: 'transparent',
                        WebkitBoxShadow: '0 0 0 1000px white inset',
                        WebkitTextFillColor: '#000000',
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                  />
                </Grid>
                <Grid item md={3} sm={12} sx={{width: '100%'}}>
                  <Typography
                    variant="h4"
                    color={'#615F6B'}
                    // sx={styles.required}
                  >
                    Maiden Name
                  </Typography>
                  <TextField
                    fullWidth
                    defaultValue={''}
                    disabled={otherMaidenNameArray.fields[0]?.value !== ''}
                    InputLabelProps={{shrink: true}}
                    {...register(`otherMaidenName.0.value` as const)}
                    error={!!errors?.otherMaidenName?.[0]?.value}
                    helperText={
                      errors?.otherMaidenName?.[0]?.value?.message || ''
                    }
                    style={{borderRadius: 5, backgroundColor: MpTheme.colors.white}}
                    sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        backgroundColor:MpTheme.colors.white,
                        '& input:-webkit-autofill': {
                        background: 'transparent',
                        WebkitBoxShadow: '0 0 0 1000px white inset',
                        WebkitTextFillColor: '#000000',
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                  />
                </Grid>
              </Grid>
            </Stack>
          </Stack>
        </Stack>
      </ThemeProvider>
    </>
  )
}

const LocationsAddressesSection: React.FC<LocationsAddressesSectionProps> = ({
    addressArray,
    register,
    errors,
  }) => {
    const isMobile = useMediaQuery('(max-width:600px)')
    const [editableIndex, setEditableIndex] = useState(-1)
  
    const handleDelete = (array: FieldValues, index: number) => {
        array.remove(index)
    }
    const handleAddAddress = () => {
      if (addressArray.fields.length <= 6) {
        addressArray.append({
          state: '' as 'CA',
          city: '',
          streetAddress: '',
          zip: ''
        })
        setEditableIndex(addressArray.fields.length)
      } else {
        Toast.show({
          type: 'warning',
          text1: 'You can not add more than 6 secondary addresses.',
        })
      }
    }
    return (
      <ThemeProvider theme={theme}>
        <Stack spacing={3}>
          <Box style={styles.inputContainer}>
            {!isMobile && (
              <Typography variant="h3" sx={styles.header}>
                Address
              </Typography>
            )}
            <Typography variant="h5" mb={10}>
              We use your information to look for additional records of yours.
              Additional information such as previous addresses and alternative
              names helps us find more of your data.
            </Typography>
  
            <Stack divider={<Divider sx={{mb: 4}}/>}>
              {addressArray.fields.map((field, index) => (
                <Box key={field.id}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      mb: 4,
                    }}>
                    {index == 0 ? (
                      <Typography variant={'h4'} color={'#040115'}>
                        Primary Address
                      </Typography>
                    ) : (
                      <Typography variant={'h4'} color={'#040115'}>
                        Address {index + 1}
                      </Typography>
                    )}
                  </Box>
                  <Grid container spacing={4} sx={{width: '100%'}}>
                    <Grid item md={2} xs={12} sm={12} sx={{width: '100%'}}>
                      <Typography
                        variant="h4"
                        color={'#615F6B'}
                        sx={Object.assign({},styles.required, styles.fieldlabel)}>
                        City
                      </Typography>
                      <TextField
                        required
                        fullWidth
                        disabled={index !== editableIndex}
                        error={!!errors?.address?.[index]?.city}
                        helperText={errors?.address?.[index]?.city?.message || ''}
                        InputLabelProps={{shrink: true}}
                        {...register(`address.${index}.city` as const)}
                        style={{backgroundColor: index !== editableIndex? '#EFEDFDB2' : MpTheme.colors.white,
                          color: index !== editableIndex? '#A0A0A4': 'black', borderRadius: 5
                        }}
                        sx={{'& input': {
                            p:0
                            },
                            '& .MuiOutlinedInput-root': {
                            fontSize: '14px',
                            p:5,
                            borderWidth: 0
                            },
                            backgroundColor:MpTheme.colors.white,
                            '& input:-webkit-autofill': {
                            background: 'transparent',
                            WebkitBoxShadow: '0 0 0 1000px white inset',
                            WebkitTextFillColor: '#000000',
                            },
                            '&.MuiTextField-root': {
                            border: 'none',
                            },
                        }}
                      />
                    </Grid>
                    <Grid item md={2} xs={12} sm={12} sx={{width: '100%'}}>
                      <Typography
                        variant="h4"
                        color={'#615F6B'}
                        sx={Object.assign({},styles.required, styles.fieldlabel)}>
                        State
                      </Typography>
                      <TextField
                        required
                        disabled={index !== editableIndex}
                        fullWidth
                        error={!!errors?.address?.[index]?.state}
                        helperText={
                          errors?.address?.[index]?.state?.message || ''
                        }
                        InputLabelProps={{shrink: true}}
                        {...register(`address.${index}.state` as const, {
                          setValueAs: (v) => v.toUpperCase(),
                        })}
                        style={{backgroundColor: index !== editableIndex? '#EFEDFDB2' : MpTheme.colors.white,
                          color: index !== editableIndex? '#A0A0A4': 'black', borderRadius: 5}}
                        sx={{'& input': {
                            p:0
                            },
                            '& .MuiOutlinedInput-root': {
                            fontSize: '14px',
                            p:5,
                            borderWidth: 0
                            },
                            backgroundColor:MpTheme.colors.white,
                            '& input:-webkit-autofill': {
                            background: 'transparent',
                            WebkitBoxShadow: '0 0 0 1000px white inset',
                            WebkitTextFillColor: '#000000',
                            },
                            '&.MuiTextField-root': {
                            border: 'none',
                            },
                        }}
                      />
                    </Grid>
                    <Grid item md={2} sm={12} sx={{width: '100%'}}>
                      <Typography variant="h4" sx={Object.assign({},styles.required, styles.fieldlabel)} color={'#615F6B'}>
                        Zip Code
                      </Typography>
                      <TextField
                        disabled={index !== editableIndex}
                        fullWidth
                        error={!!errors?.address?.[index]?.zip}
                        helperText={errors?.address?.[index]?.zip?.message || ''}
                        InputLabelProps={{shrink: true}}
                        {...register(`address.${index}.zip` as const)}
                        style={{backgroundColor: index !== editableIndex? '#EFEDFDB2' : MpTheme.colors.white,
                          color: index !== editableIndex? '#A0A0A4': 'black', borderRadius: 5}}
                        sx={{'& input': {
                        p:0
                        },
                        '& .MuiOutlinedInput-root': {
                        fontSize: '14px',
                        p:5,
                        borderWidth: 0
                        },
                        backgroundColor:MpTheme.colors.white,
                        '& input:-webkit-autofill': {
                        background: 'transparent',
                        WebkitBoxShadow: '0 0 0 1000px white inset',
                        WebkitTextFillColor: '#000000',
                        },
                        '&.MuiTextField-root': {
                        border: 'none',
                        },
                    }}
                      />
                    </Grid>
                    <Grid item md={5} sm={12} sx={{width: '100%'}}>
                      <Typography variant="h4" sx={styles.fieldlabel} color={'#615F6B'}>
                        Street Address*
                      </Typography>
                      <TextField
                        fullWidth
                        disabled={index !== editableIndex}
                        error={!!errors?.address?.[index]?.streetAddress}
                        helperText={
                          errors?.address?.[index]?.streetAddress?.message || ''
                        }
                        InputLabelProps={{shrink: true}}
                        {...register(`address.${index}.streetAddress` as const)}
                        style={{backgroundColor: index !== editableIndex? '#EFEDFDB2' : MpTheme.colors.white,
                          color: index !== editableIndex? '#A0A0A4': 'black', borderRadius: 5}}
                          sx={{'& input': {
                            p:0
                            },
                            '& .MuiOutlinedInput-root': {
                            fontSize: '14px',
                            p:5,
                            borderWidth: 0
                            },
                            backgroundColor:MpTheme.colors.white,
                            '& input:-webkit-autofill': {
                            background: 'transparent',
                            WebkitBoxShadow: '0 0 0 1000px white inset',
                            WebkitTextFillColor: '#000000',
                            },
                            '&.MuiTextField-root': {
                            border: 'none',
                            },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      md={1}
                      sm={12}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: !isMobile? 'space-between': 'flex-end',
                        alignItems: 'center',
                      }}>
                      <img
                          onClick={() => {
                            if (index === editableIndex) {
                              setEditableIndex(-1)
                            }
                            else{
                              setEditableIndex(index)
                            }
                          }}
                          src={editIcon}
                          alt="Description of the image"
                          style={{
                            cursor: 'pointer',
                            maxWidth: '40px',
                            maxHeight: '40px',
                            marginTop: '10px',
                            marginRight: isMobile? '5px':'0px'
                          }}
                        />
                      {index != 0 && (
                        <img
                          onClick={() => {
                            handleDelete(addressArray, index)
                          }}
                          src={deleteIcon}
                          alt="Description of the image"
                          style={{
                            cursor: 'pointer',
                            maxWidth: '40px',
                            maxHeight: '40px',
                            marginTop: '10px',
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid item md={3} sm={3} mt={5}>
                    {index === addressArray.fields.length - 1 && (
                      <Button
                        variant={'contained'}
                        sx={{
                          height: 50,
                          borderRadius: '10px',
                          boxShadow: 'unset',
                          border: '2px solid #C67EFF',
                          background: 'transparent',
                          color: '#C67EFF',
                          '&.Mui-disabled': {
                            background: 'transparent',
                            color: '#C67EFF',
                          },
                          ':hover': {
                            background: 'transparent',
                            color: '#C67EFF',
                          },
                        }}
                        onClick={() => {
                          handleAddAddress()
                        }}>
                        Add Address
                      </Button>
                    )}
                  </Grid>
                </Box>
              ))}
            </Stack>
          </Box>
        </Stack>
      </ThemeProvider>
    )
  }

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
                                                                 emailArray,
                                                                 phoneNumberArray,
                                                                 register,
                                                                 errors,
                                                               }) => {
  const handleDelete = (array: FieldValues, index: number) => {
    array.remove(index)
    array.append({value: ''})
  }
  const addSecondaryNumberOrEmail = (array: FieldValues, type: string) => {
    if (array.fields.length < 5) {
      if (array.fields.length === 0) {
        array.insert(array.fields.length, {
          value: '',
        })
        array.swap(1, 0)
      } else if (array.fields.length === 1) {
        array.insert(array.fields.length, {
          value: '',
        })
        // array.insert(0, {
        //   value: array.fields[0].value,
        // })
      } else {
        array.insert(array.fields.length, {
          value: '',
        })
      }
    } else {
      array.insert(array.fields.length, {
        value: '',
      })
      array.remove(5)
      setTimeout(() => {
        Toast.show({
          type: 'warning',
          text1:
            type === 'email'
              ? 'You can not add more than 4 secondary emails.'
              : 'You can not add more than 4 secondary numbers.',
        })
      }, 500)
    }
  }

  const isMobile = useMediaQuery('(max-width:600px)')
  return (
    <Box sx={{flexDirection: isMobile ? 'column' : 'row'}}>
      {!isMobile && (
        <Typography variant="h3" sx={styles.header}>
          Phone Number
        </Typography>
      )}

      {phoneNumberArray.fields.length ? (
        <Typography variant="h5" mb={5}>
          Primary Number :
        </Typography>
      ) : (
        <Typography variant="h5" mb={1}></Typography>
      )}

      {phoneNumberArray.fields.length === 0 && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item md={6} sm={12} sx={{width: isMobile ? '100%' : 'unset'}}>
            <TextField
              type="tel"
              fullWidth
              sx={{'& input': {
                p:0
                },
                '& .MuiOutlinedInput-root': {
                fontSize: '14px',
                p:6,
                borderWidth: 0
                },
                backgroundColor:MpTheme.colors.white,
                '& input:-webkit-autofill': {
                background: 'transparent',
                WebkitBoxShadow: '0 0 0 1000px white inset',
                WebkitTextFillColor: '#000000',
                },
                '&.MuiTextField-root': {
                border: 'none',
                },
            }}
              maxLength={10}
              error={!!errors?.phoneNumber?.[0]?.value}
              helperText={errors?.phoneNumber?.[0]?.value?.message ?? ''}
              placeholder="Enter Number"
              {...register(`phoneNumber.${0}.value` as const)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={CountryCode}
                      width="24px"
                      style={{marginRight: 2}}
                    />
                    <span style={{fontSize: '14px', color: '#757575'}}>
                      +1
                    </span>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            {phoneNumberArray.fields.length == 0 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() =>
                  addSecondaryNumberOrEmail(phoneNumberArray, 'number')
                }
                sx={{
                  width: '100%',
                  height: 50,
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  border: '2px solid #C67EFF',
                  background: 'transparent',
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                Add Number
              </Button>
            )}
          </Grid>
        </Grid>
      )}
      {phoneNumberArray.fields.map((field, index) => (
        <Grid container key={field.id} spacing={2} alignItems="center" mt={2}>
          <Grid item md={6} sm={12} sx={{width: isMobile ? '100%' : 'unset'}}>
            <TextField
              fullWidth
              sx={{'& input': {
                p:0
                },
                '& .MuiOutlinedInput-root': {
                fontSize: '14px',
                p:6,
                borderWidth: 0
                },
                '& input:-webkit-autofill': {
                background: 'transparent',
                WebkitBoxShadow: '0 0 0 1000px white inset',
                WebkitTextFillColor: '#000000',
                },
                '&.MuiTextField-root': {
                border: 'none',
                },
            }}
            style={{backgroundColor: (index <= phoneNumberArray.fields.length - 1 &&
              phoneNumberArray.fields[index].value !== '')? '#EFEDFDB2' : MpTheme.colors.white,
              color: (index <= phoneNumberArray.fields.length - 1 &&
                phoneNumberArray.fields[index].value !== '')? '#A0A0A4': 'black', borderRadius: 5}}
              type="tel"
              // disabled={index===0 && phoneNumberArray.fields.length > 1}
              disabled={
                index <= phoneNumberArray.fields.length - 1 &&
                phoneNumberArray.fields[index].value !== ''
              }
              error={!!errors?.phoneNumber?.[index]?.value}
              helperText={errors?.phoneNumber?.[index]?.value?.message ?? ''}
              {...register(`phoneNumber.${index}.value` as const)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={CountryCode}
                      width="24px"
                      style={{marginRight: 2}}
                    />
                    <span style={{fontSize: '14px', color: '#757575'}}>
                      +1
                    </span>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            {index === phoneNumberArray.fields.length - 1 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() =>
                  addSecondaryNumberOrEmail(phoneNumberArray, 'number')
                }
                sx={{
                  width: '100%',
                  height: 50,
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  border: '2px solid #C67EFF',
                  background: 'transparent',
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                Add Number
              </Button>
            )}
          </Grid>
        </Grid>
      ))}

      {phoneNumberArray.fields.length > 0 && (
        <Typography variant="body2" mt={5}>
          {phoneNumberArray.fields.map((field, indexphone) => {
            if (field.value.trim() !== '' && indexphone != 0) {
              return (
                <Grid container alignItems="center" key={indexphone}>
                  <Grid item md={3}>
                    {field.value}
                    <p style={{margin: 0, color: '#A0A0A4'}}></p>
                  </Grid>
                  <Grid item md={3}>
                    <img
                      onClick={() => handleDelete(phoneNumberArray, indexphone)}
                      src={deleteIcon}
                      alt="Description of the image"
                      style={{
                        cursor: 'pointer',
                        maxWidth: '50px',
                        maxHeight: '50px',
                        marginLeft: '10px',
                      }}
                    />
                  </Grid>
                </Grid>
              )
            }
            return null
          })}
        </Typography>
      )}

      <Divider sx={Object.assign({}, styles.borderBlack, styles.mb1)}/>
      <Typography variant="h3" sx={styles.header}>
        Email
      </Typography>
      {emailArray.fields.length ? (
        <Typography variant="h5" mb={5}>
          Primary Email :
        </Typography>
      ) : (
        <Typography variant="h5" mb={1}></Typography>
      )}
      {/* {emailArray.fields.length===1 && (
          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid item md={6} sm={12} sx={{ width: isMobile ? '100%' : 'unset' }}>
              <TextField
                sx={{ width: '100%', background: '#fff' }}
                placeholder="Enter Email..."
                disabled={true}
                error={!!errors?.email?.[0]?.value} helperText={errors?.email?.[0]?.value?.message || ''}
                value={emailArray.fields[0].value}
              />
            </Grid>
          </Grid>
        )} */}
      {emailArray.fields.length === 0 && (
        <Grid container spacing={2} alignItems="center" mt={2}>
          <Grid item md={6} sm={12} sx={{width: isMobile ? '100%' : 'unset'}}>
            <TextField
              fullWidth
              sx={{'& input': {
                p:0
                },
                '& .MuiOutlinedInput-root': {
                fontSize: '14px',
                p:6,
                borderWidth: 0
                },
                backgroundColor:MpTheme.colors.white,
                '& input:-webkit-autofill': {
                background: 'transparent',
                WebkitBoxShadow: '0 0 0 1000px white inset',
                WebkitTextFillColor: '#000000',
                },
                '&.MuiTextField-root': {
                border: 'none',
                },
            }}
              placeholder="Enter Email..."
              error={!!errors?.email?.[0]?.value}
              helperText={errors?.email?.[0]?.value?.message || ''}
              {...register(`email.${0}.value` as const, {
                setValueAs: (value) => value.trim(),
              })}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            {emailArray.fields.length === 0 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() => addSecondaryNumberOrEmail(emailArray, 'email')}
                sx={{
                  width: '100%',
                  height: 50,
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  border: '2px solid #C67EFF',
                  background: 'transparent',
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                Add Email
              </Button>
            )}
          </Grid>
        </Grid>
      )}
      {emailArray.fields.map((field, index) => (
        <Grid container spacing={2} key={field.id} alignItems="center" mt={2}>
          <Grid item md={6} sm={12} sx={{width: isMobile ? '100%' : 'unset'}}>
            <TextField
              fullWidth
              sx={{'& input': {
                p:0
                },
                '& .MuiOutlinedInput-root': {
                fontSize: '14px',
                p:6,
                borderWidth: 0
                },
                '& input:-webkit-autofill': {
                background: 'transparent',
                WebkitBoxShadow: '0 0 0 1000px white inset',
                WebkitTextFillColor: '#000000',
                },
                '&.MuiTextField-root': {
                border: 'none',
                },
            }}
            style={{backgroundColor: ( index <= emailArray.fields.length - 1 &&
              emailArray.fields[index].value !== '')? '#EFEDFDB2' : MpTheme.colors.white,
              color: ( index <= emailArray.fields.length - 1 &&
                emailArray.fields[index].value !== '')? '#A0A0A4': 'black', borderRadius: 5}}
              placeholder="Enter Email..."
              // disabled={index===0 && emailArray.fields.length > 1}
              disabled={
                index <= emailArray.fields.length - 1 &&
                emailArray.fields[index].value !== ''
              }
              error={!!errors?.email?.[index]?.value}
              helperText={errors?.email?.[index]?.value?.message || ''}
              {...register(`email.${index}.value` as const, {
                setValueAs: (value) => value.trim(),
              })}
            />
          </Grid>
          <Grid item md={3} sm={12}>
            {index === emailArray.fields.length - 1 && (
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={() => addSecondaryNumberOrEmail(emailArray, 'email')}
                sx={{
                  width: '100%',
                  height: 50,
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  border: '2px solid #C67EFF',
                  background: 'transparent',
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                Add Email
              </Button>
            )}
          </Grid>
        </Grid>
      ))}
      {emailArray.fields.length > 0 && (
        <Typography variant="body2" mt={5}>
          {emailArray.fields.map(
            (email, indexemail) =>
              email.value.trim() !== '' &&
              indexemail > 0 && (
                <Grid container alignItems="center" key={email.id}>
                  <Grid item md={6}>
                    {email.value}

                    <p style={{margin: 0, color: '#A0A0A4'}}></p>
                  </Grid>

                  <Grid item md={3}>
                    <img
                      onClick={() => handleDelete(emailArray, indexemail)}
                      src={deleteIcon}
                      alt="Description of the image"
                      style={{
                        cursor: 'pointer',
                        maxWidth: '50px',
                        maxHeight: '50px',
                        marginLeft: '10px',
                      }}
                    />
                  </Grid>
                </Grid>
              ),
          )}
        </Typography>
      )}
    </Box>
  )
}

export const ExecutiveUserProfileDashboard = ({ isModalOpen, muid, setIsModalOpen }: ProfileDashboardProps) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const dispatch = useAppDispatch()
    const [fetchedForMuid, setFetchedForMuid] = useState<string | null>(null)
    const location = useLocation()
    const initialSection = location.state?.index || 0
    const [currentSection, setCurrentSection] = useState(initialSection)
    const [openSections, setOpenSections] = useState<number[]>(initialSection !== 0 ? [initialSection] : [])
    const [isScanDisabled, setIsScanDisabled] = useState(true)
    const [storeOriginalValues,setStoreOriginalValues] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const defaultModalStyle = {
		position: 'absolute' as const,
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		bgcolor: 'background.paper',
		boxShadow: 10,
		borderRadius: 5,
		py: 2.5,
		maxHeight: '80vh',
		overflowY: 'auto',
		width: '95%',
	}
  
    const handleModalClose=()=>{
      setIsScanDisabled(true)
      setStoreOriginalValues(false)  
      originalValuesRef.current = {
          addressArray: '',
          otherFirstNameArray: '',
          otherMaidenNameArray: '',
          emailArray: '',
          phoneNumberArray: '',
          linkedIn: '',
          checkChanged: false
        }
        setIsModalOpen(false)
        reset()
        setFetchedForMuid(null)
        setIsLoading(true)      
  }

  const {
    firstNameArray,
    lastNameArray,
    middleNameArray,
    otherFirstNameArray,
    otherMaidenNameArray,
    addressArray,
    emailArray,
    phoneNumberArray,
    register,
    errors,
    control,
    watch,
    setValue,
    handleSubmit,
    submitHandler,
    trigger,
    reset,
  } = useProfileForm({
    middleNameOptional: true,
    linkedinOptional: true,
    streetOptional: false,
    agreeToTermsOptional: false,
    muid,
    handleClose: handleModalClose
  })


  useEffect(() => {
    if (isModalOpen && muid && fetchedForMuid!=muid) {
      (async () => {
        try {
          setFetchedForMuid(muid)
          setIsLoading(true)
          const response = await dispatch(FetchExecutiveEmployeeProfile(muid))
          //@ts-ignore
          const formData = fromProfileFields(response.payload)
          reset(formData)
        } catch (error) {
          console.error(`Failed to fetch profile for MUID ${muid}`, error)
          reset(emptyProfileSchema())
        }
        finally{
            setIsLoading(false)
            setStoreOriginalValues(true)
        }
      })()
    }

    if (!isModalOpen) {
      reset(emptyProfileSchema())
    }
  }, [isModalOpen, muid, reset, dispatch, fetchedForMuid, setStoreOriginalValues, setIsLoading])


  const sections = ['Basic Info', 'Address', 'Phone & Email']
  const handleSectionChangeWeb = (sectionIndex: number) => {
    setCurrentSection(sectionIndex)
  }
  const handleSectionChange = (sectionIndex: number) => {
    setOpenSections((prevOpenSections) => {
      const isOpen = prevOpenSections.includes(sectionIndex)
      return isOpen
        ? prevOpenSections.filter((item) => item !== sectionIndex)
        : [...prevOpenSections, sectionIndex]
    })
  }

  const originalValuesRef = useRef({
    addressArray: '',
    otherFirstNameArray: '',
    otherMaidenNameArray: '',
    emailArray: '',
    phoneNumberArray: '',
    linkedIn: '',
    checkChanged: false
  });
  
  const addressArrayValue = watch('address');
  const otherFirstNameArrayValue = watch('otherFirstName');
  const otherMaidenNameArrayValue = watch('otherMaidenName');
  const emailArrayValue = watch('email');
  const phoneNumberArrayValue = watch('phoneNumber');

  useEffect(() => {
    if(storeOriginalValues){
    if (originalValuesRef.current.addressArray === "" && addressArray.fields.length >=1) {
      originalValuesRef.current.addressArray = JSON.stringify(addressArray.fields.map(({ id:_, ...rest }) => rest));
        
      if (originalValuesRef.current.otherFirstNameArray === "" && otherFirstNameArray) {
        originalValuesRef.current.otherFirstNameArray = JSON.stringify(otherFirstNameArray.fields.map(({ id:_, ...rest }) => rest));
      }
      
      if (originalValuesRef.current.otherMaidenNameArray === "" && otherMaidenNameArray) {
        originalValuesRef.current.otherMaidenNameArray = JSON.stringify(otherMaidenNameArray.fields.map(({ id:_, ...rest }) => rest));
      }
      
      if (originalValuesRef.current.emailArray === "" && emailArray) {
        originalValuesRef.current.emailArray = JSON.stringify(emailArray.fields.map(({ id:_, ...rest }) => rest));
      }
      
      if (originalValuesRef.current.phoneNumberArray === "" && phoneNumberArray) {
        if(phoneNumberArray.fields.length === 0){
          originalValuesRef.current.phoneNumberArray = JSON.stringify([{"value":""}]);
        }
        else{
          originalValuesRef.current.phoneNumberArray = JSON.stringify(phoneNumberArray.fields.map(({ id:_, ...rest }) => rest));
        }
      }

      originalValuesRef.current.checkChanged = true;
    }}

    const hasNumberChanged = () =>{
      if(phoneNumberArrayValue.length === 0){
        return false;
      }
      else{
        return JSON.stringify(phoneNumberArrayValue) !== originalValuesRef.current.phoneNumberArray && 
        phoneNumberArrayValue.every((value:any)=> value.value != "");
      }
    }

    const hasFormChanged = () =>{
      if(JSON.stringify(addressArrayValue) !== originalValuesRef.current.addressArray && addressArrayValue.every((value:any)=>value.city !="")){
        return true
      }
      if(JSON.stringify(otherFirstNameArrayValue) !== originalValuesRef.current.otherFirstNameArray ||
      JSON.stringify(otherMaidenNameArrayValue) !== originalValuesRef.current.otherMaidenNameArray){
        return true
      }
      if(JSON.stringify(emailArrayValue) !== originalValuesRef.current.emailArray && emailArrayValue.every((value:any)=> value.value!="")){
        return true
      }
      if(hasNumberChanged()){
        return true
      }
      return false
    }

    if(originalValuesRef.current.checkChanged){
      setIsScanDisabled(!hasFormChanged());
    }
    
    
  }, [addressArray, addressArrayValue, emailArray, emailArrayValue, otherFirstNameArray, 
    otherFirstNameArrayValue, otherMaidenNameArray, otherMaidenNameArrayValue, phoneNumberArray, phoneNumberArrayValue, storeOriginalValues]);

  const getBody = () => {
    return (
      <Container sx={defaultModalStyle} >
        <Container sx={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent:'space-between', alignItems:'center'}}>
            <Typography variant="h2">
                User Profile Management
            </Typography>
            <IconButton
				edge="end"
				color="inherit"
				onClick={handleModalClose}
				sx={{
						zIndex: 1,
						color: '#ffffff',
					}}>
				<img src={closeicon} style={{width: '42px'}}/>
			</IconButton>
        </Container>
        {isMobile ? (
        <Stack
          spacing={0}
          component={'form'}
          onSubmit={handleSubmit(submitHandler)}
          flexDirection={'column'}>
          <Card sx={{position: 'relative'}}>
            {sections.map((section, index) => (
              <React.Fragment key={index}>
                <ListItem disablePadding>
                      <ListItemButton
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                        onClick={() => handleSectionChange(index)}>
                        <Typography variant="body1" sx={{color: '#1A1B20'}}>
                          {section}
                        </Typography>
                        {openSections.includes(index) ? (
                          <ExpandLess/>
                        ) : (
                          <ExpandMore/>
                        )}
                      </ListItemButton>
                </ListItem>
               <Collapse
                  in={openSections.includes(index)}
                  timeout="auto"
                  unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      disablePadding
                      sx={{
                        width: 'calc(100% - 30px)',
                        marginLeft: 2,
                        marginRight: 2,
                        p: 2,
                      }}>
                        {
                            isLoading &&
                            <div style={{height:'100%', width:'100%', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                                <CircularProgress color = 'info'></CircularProgress>
                            </div>
                        }
                      {!isLoading && index === 0 && (
                        <PersonalInfoSection
                          watch={watch}
                          setValue={setValue}
                          firstNameArray={firstNameArray}
                          middleNameArray={middleNameArray}
                          lastNameArray={lastNameArray}
                          otherFirstNameArray={otherFirstNameArray}
                          otherMaidenNameArray={otherMaidenNameArray}
                          register={register}
                          errors={errors}
                          control={control}
                          trigger={trigger}
                          muid={muid}
                        />
                      )}
                      {!isLoading && index === 1 && (
                        <LocationsAddressesSection
                          addressArray={addressArray}
                          register={register}
                          errors={errors}
                          control={control}
                        />
                      )}
                      {!isLoading && index === 2 && (
                        <ContactInfoSection
                          setValue={setValue}
                          emailArray={emailArray}
                          phoneNumberArray={phoneNumberArray}
                          register={register}
                          errors={errors}
                          control={control}
                        />
                      )}
                    </ListItem>
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
            <Typography variant="body2" sx={{mt: 5, pb: 3, my: 1, mx: 2}}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <img
                  src={shieldicon}
                  alt="Description of the image"
                  style={{
                    maxWidth: '50px',
                    maxHeight: '50px',
                    marginRight: '10px',
                  }}
                />
                <div>
                  <p style={{margin: 0, color: '#A0A0A4'}}>
                    mePrism uses industry-standard encryption to protect
                    confidentiality of all information you provide. We do not
                    sell your data.
                  </p>
                </div>
              </div>
            </Typography>
           
            <Button
              variant={'contained'}
              disabled={isScanDisabled}
              type={'submit'}
              onClick={handleSubmit(submitHandler)}
              sx={{
                mx:2, my: 1,
                border: '2px solid #426bf0',
                    background: '#426bf0',
                    color: '#fff',
                  '&.Mui-disabled': {
                      background: 'white',
                      color: '#A0A0A4',
                      border: '2px solid #A0A0A4',
                      opacity: 0.7,
                    },
                    ':hover': {
                        background: '#426bf0',
                        color: '#fff',
                  }
                 }}>
              Save Changes & Run New Scan
            </Button>
          </Card>
        </Stack>
      ) : (
        <PageLayout>
          <Stack
            component={'form'}
            onSubmit={handleSubmit(submitHandler)}>
            <Grid container>
              <Grid item md={3} xs={3} sx={{position:"relative"}}>
                <Sidebar
                  sections={sections}
                  onSectionChange={handleSectionChangeWeb}
                />
                <Button
                variant={'contained'}
                disabled={isScanDisabled}
                onClick={handleSubmit(submitHandler)}
                type={'submit'}
                sx={{
                    border: '2px solid #426bf0',
                    background: '#426bf0',
                    width:'100%',
                    fontSize:'12px',
                    p:1.5,
                    position:"absolute",
                    bottom:0,
                    left:0,
                    color: '#fff','&.Mui-disabled': {
                      background: 'white',
                      color: '#A0A0A4',
                      border: '2px solid #A0A0A4',
                      opacity: 0.7,
                    },
                    ':hover': {
                        background: '#426bf0',
                        color: '#fff',
                  }
                   }}>
                Save Changes & Run New Scan
              </Button>
              </Grid>
              <Grid item md={8.7} xs={8.7} sx={{ml: 5}}>
                {' '}
                <Card
                  sx={{
                    height: '68vh',
                    p: 5,
                    position: 'relative',
                    overflow: 'auto',
                  }}>
                  <div style={{position: 'relative', minHeight: '90%'}}>
                    {
                        isLoading &&
                        <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <CircularProgress color="info"/>
                        </div>
                    }
                    {!isLoading && currentSection === 0 && (
                      <PersonalInfoSection
                        watch={watch}
                        setValue={setValue}
                        firstNameArray={firstNameArray}
                        middleNameArray={middleNameArray}
                        lastNameArray={lastNameArray}
                        otherFirstNameArray={otherFirstNameArray}
                        otherMaidenNameArray={otherMaidenNameArray}
                        register={register}
                        errors={errors}
                        control={control}
                        trigger={trigger}
                        muid={muid}
                      />
                    )}
                    {!isLoading && currentSection === 1 && (
                      <LocationsAddressesSection
                        addressArray={addressArray}
                        register={register}
                        errors={errors}
                        control={control}
                      />
                    )}

                    {!isLoading && currentSection === 2 && (
                      <ContactInfoSection
                        setValue={setValue}
                        emailArray={emailArray}
                        phoneNumberArray={phoneNumberArray}
                        register={register}
                        errors={errors}
                        control={control}
                      />
                    )}
                    {!isLoading &&
                    <Typography
                      variant="body2"
                      sx={{position: 'absolute', bottom: -60}}>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <img
                          src={shieldicon}
                          alt="Description of the image"
                          style={{
                            maxWidth: '50px',
                            maxHeight: '50px',
                            marginRight: '10px',
                          }}
                        />
                        <div>
                          <p style={{margin: 0, color: '#A0A0A4'}}>
                            mePrism uses industry-standard encryption to protect
                            confidentiality of all information you provide. We
                            do not sell your data.
                          </p>
                        </div>
                      </div>
                    </Typography>}
                  </div>
                </Card>
              </Grid>
            </Grid>
          </Stack>
        </PageLayout>
      )}

      </Container>
    )
  }


  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      sx={{ backdropFilter: 'blur(5px)' }}
    >
      {getBody()}
    </Modal>
  )
}
